import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import HubspotFormComponent from 'webapp/components/hubspot-form';
import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';

export default class AccountPopupPartnerComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('request') declare requestService: Service.Request;

	formId = '34ee4843-d20c-4e54-abda-d372328d1eee';

	@action
	onFormSubmit() {
		this.requestService
			.api('POST', '/account-progress/partner-listed', null, { withoutPrefix: true })
			.catch(this.requestService.handleGenericThrownError.bind(this.requestService));
	}
	<template>
		<div class="title">
			Get listed in partner directory
		</div>
		<div class="content">
			<HubspotFormComponent
				@formId={{this.formId}}
				@prefillEmail={{true}}
				@onSubmit={{this.onFormSubmit}}
				@onContentChange={{this.reposition}}
			/>
		</div>
	</template>
}
